import { Component, Input } from '@angular/core';

@Component({
  selector: 'hf-verified-epc-pill',
  templateUrl: './verified-epc-pill.component.html',
  styleUrls: ['./verified-epc-pill.component.scss']
})
export class VerifiedEpcPillComponent {
  @Input() epcDateValidUntil: Date;
  @Input() epcRatingExpired: boolean | null;
}
